import React, { ChangeEvent, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import classes from './chat.module.scss';
import { Mutation } from 'react-apollo';
import { GET_CHAT, GET_CHATS } from '../../queries';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import gql from 'graphql-tag';

const ADD_MESSAGE = gql`
  mutation AddMessage($chatId: String!, $message: String!) {
    addMessage(chatId: $chatId, message: $message) {
      id
      chatId
      text
      author {
        id
        firstName
        lastName
        image
      }
      createdAt
    }
  }
`;

const AddMessage = ({ id }) => {
  const [text, updateText] = useState('');
  const sendMessage = (mutationFn: () => void) => {
    mutationFn();
    updateText('');
  };

  return (
    <div>
      <TextField
        placeholder="Написати повідомлення"
        fullWidth
        multiline
        rows="4"
        className={classes.textField}
        value={text}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          updateText(e.target.value)
        }
        margin="normal"
        variant="outlined"
      />
      <Mutation
        mutation={ADD_MESSAGE}
        variables={{ chatId: id, message: text }}
        update={(store, { data }) => {
          try {
            const cachedChats = store.readQuery({ query: GET_CHATS });
            // @ts-ignore
            const oldChat = cachedChats.userChats.find(chat => chat.id === id);
            const updatedChat = {
              ...oldChat,
              lastMessage: data.addMessage
            };
            // @ts-ignore
            const filteredChats = cachedChats.userChats.filter(
              chat => chat.id !== data.addMessage.chatId
            );
            const newData = {
              userChats: [updatedChat, ...filteredChats]
            };

            store.writeQuery({ query: GET_CHATS, data: newData });
          } catch {
            // Not queried yet, ignore
          }

          try {
            const cachedChat = store.readQuery({
              query: GET_CHAT,
              variables: { id }
            });
            // @ts-ignore
            cachedChat.chat.messages.push(data.addMessage);
            store.writeQuery({
              query: GET_CHAT,
              variables: { id },
              data: cachedChat
            });
          } catch {
            // Not queried yet, ignore
          }
        }}
      >
        {(addMessageMutation, { loading }) => {
          if (loading) {
            return (
              <div style={{ textAlign: 'center' }}>
                <CircularProgress />
              </div>
            );
          }

          return (
            <Button
              variant="outlined"
              className={classes.actionButton}
              onClick={() => sendMessage(addMessageMutation)}
              disabled={!text.trim()}
            >
              Надіслати
            </Button>
          );
        }}
      </Mutation>
    </div>
  );
};

export default AddMessage;
